import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../styles/home.css";
import { Col, Dropdown, Row, Tooltip } from "antd";
import { Box, Button, Text, Flex } from "@chakra-ui/react";
import { HamMenu } from "./HamMenu";
import { routes_data } from "../../constants/StaticData";
import { FormattedMessage } from "react-intl";
import { FaRegUserCircle, FaSignOutAlt, FaRegHeart, FaRegStar } from "react-icons/fa";
import { FiGlobe } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { setLoginModalVisible } from "../../redux/reducers/globalReducer";
import { useIntl } from "react-intl";
import { Login } from "../login";
import { RxDashboard } from "react-icons/rx";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useQuery } from "@tanstack/react-query";
import { authAxios } from "../../utils/axiosMiddleware";
import { setProfileData } from "../../redux/reducers/UserReducer";
import { HandleArabicClick, HandleEnglishClick } from "../../utils/Helper";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useIntl();
  const [hamMenu, setHamMenu] = useState(false);
  const [hamburgerActive, setHamburgerActive] = useState(false);
  const [mobileView, setMobileView] = useState(window.innerWidth < 1210);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 560);

  useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth < 1210);
      setIsSmallScreen(window.innerWidth < 560);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleHamMenu = () => {
    setHamMenu(!hamMenu);
    setHamburgerActive(!hamburgerActive);
  };

  const auth = JSON.parse(localStorage.getItem("userData"));
  const items = [
    {
      label: (
        <span style={{ color: "#000", fontWeight: "500" }}>
          <FormattedMessage id="view_dashboard" />
        </span>
      ),
      key: "0",
      icon: <RxDashboard style={{ color: "#000" }} />,
      onClick: () => navigate("/user-dashboard"),
    },
    {
      label: (
        <span style={{ color: "#000", fontWeight: "500" }}>
          <FormattedMessage id="Logout" />
        </span>
      ),
      key: "2",
      icon: <FaSignOutAlt style={{ color: "#000" }} />,
      onClick: () => {
        localStorage.removeItem("userData");
        window.location.replace("/");
      },
    },
  ];

  const {
    data: profileData,
    isError,
    isSuccess,
  } = useQuery({
    enabled: !!auth,
    queryKey: ["me"],
    queryFn: () => authAxios.get("/auth/me"),
    retry: false,
    select: (data) => data?.data,
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        setProfileData({
          profileName: profileData?.name,
          email: profileData?.email,
          roles: profileData?.["userRolePermissions"],
          permissions: profileData?.permissions,
          id: profileData?.id,
          userLanguage: profileData?.["languagePreference"],
        })
      );
    } else if (isError) {
      localStorage.removeItem("userData");
      window.location.href = "/";
    }
  }, [isSuccess, isError, profileData, dispatch]);

  const isHomePage = location.pathname === "/";


  return (
    <Box
      as="header"
      position={
        isHomePage ||
          location.pathname.startsWith("/about-us") ||
          location.pathname.startsWith("/contact-us")
          ? "absolute" : "relative"
      }
      top={0}
      left={0}
      width="100%"
      zIndex={2000}
    >
      {/* Top Utility Bar */}
      <Box
        bg={isHomePage ? "rgba(0, 0, 0, 0.05)" : "#f8f9fa"}
        color={isHomePage ? "white" : "black"}
        py={{ base: 2, md: 3 }}
        px={{ base: 4, md: "60px" }}
        borderBottom={isHomePage ? "0.5px solid rgba(255, 255, 255, 0.1)" : "1px solid #eee"}
      >
        <Flex justify="space-between" align="center" maxW="1650px" mx="auto">
          <Flex align="center" gap={4}>
            <Flex
              align="center"
              gap={1}
              cursor="pointer"
              onClick={locale === "en" ? HandleArabicClick : HandleEnglishClick}
              px={3}
              py={1.5}
              borderRadius="md"
              transition="all 0.2s"
              _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)" }}
            >
              <FiGlobe />
              <Text fontSize="sm" fontWeight="600" mb={0}>
                {locale === "en" ? "AR" : "EN"}
              </Text>
            </Flex>
          </Flex>
          <Flex align="center" gap={{ base: 4, md: 6 }}>
            <Flex
              align="center"
              gap={2}
              cursor="pointer"
              onClick={() => {
                if (!auth) {
                  dispatch(setLoginModalVisible(true));
                } else {
                  navigate("/user-dashboard", { state: { tab: "savedProperties" } });
                }
              }}
              px={3}
              py={1.5}
              borderRadius="md"
              transition="all 0.2s"
              _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)" }}
            >
              <FaRegHeart />
              <Text fontSize="sm" display={{ base: "none", sm: "block" }} mb={0}>
                <FormattedMessage id="favourite_properties" />
              </Text>
            </Flex>
            <Flex
              align="center"
              gap={2}
              cursor="pointer"
              onClick={() => {
                if (!auth) {
                  dispatch(setLoginModalVisible(true));
                } else {
                  navigate("/user-dashboard", { state: { tab: "savedSearches" } });
                }
              }}
              px={3}
              py={1.5}
              borderRadius="md"
              transition="all 0.2s"
              _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)" }}
            >
              <FaRegStar />
              <Text fontSize="sm" display={{ base: "none", sm: "block" }} mb={0}>
                <FormattedMessage id="saved_searches" />
              </Text>
            </Flex>
            {!auth ? (
              <Flex
                align="center"
                gap={2}
                cursor="pointer"
                onClick={() => dispatch(setLoginModalVisible(true))}
                px={3}
                py={1.5}
                borderRadius="md"
                transition="all 0.2s"
                _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)" }}
              >
                <FaRegUserCircle />
                <Text fontSize="sm" fontWeight="bold" color="#e5be54" mb={0}>
                  <FormattedMessage id="Login" />
                </Text>
              </Flex>
            ) : (
              <Dropdown
                menu={{ items }}
                trigger={["click"]}
                placement="bottomRight"
                overlayStyle={{ zIndex: 5001 }}
              >
                <Flex
                  align="center"
                  gap={2}
                  cursor="pointer"
                  px={3}
                  py={1.5}
                  borderRadius="md"
                  transition="all 0.2s"
                  _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)" }}
                >
                  <FaRegUserCircle />
                  <Text fontSize="sm">{profileData?.name}</Text>
                </Flex>
              </Dropdown>
            )}
          </Flex>
        </Flex>
      </Box>

      {/* Main Logo & Nav Bar */}
      <Flex
        className="home-header-container"
        justify="space-between"
        align="center"
        bg={isHomePage ? "transparent" : "#ffffff"}
        boxShadow={isHomePage ? "none" : "0 2px 10px rgba(0,0,0,0.1)"}
        width="100%"
        px={{ base: 4, md: "60px" }}
        py={3}
      >
        <Flex align="center" gap={4}>
          <Link to="/">
            <img
              src="/icons/sandseeker_logo.svg"
              alt="sandseekers_logo"
              style={{
                width: mobileView ? "140px" : "180px",
              }}
            />
          </Link>
        </Flex>

        {mobileView && (
          <img
            src="/icons/Hamburger.png"
            className="hamburgerMenu"
            alt="hamburgerMenu"
            onClick={handleHamMenu}
            style={{
              filter: isHomePage || hamburgerActive ? "invert(100%)" : "none",
              cursor: "pointer",
              width: "24px",
            }}
          />
        )}

        {!mobileView && (
          <Flex align="center" gap={{ base: 4, lg: 16 }}>
            {routes_data.map((route) => (
              <Box
                key={route.name}
                onClick={() => navigate(route.path)}
                color={isHomePage ? "white" : "black"}
                cursor="pointer"
                fontWeight="500"
                fontSize="16px"
                display="flex"
                alignItems="center"
                gap={1.5}
                px={4}
                py={2}
                borderRadius="md"
                transition="all 0.2s"
                _hover={{ bg: isHomePage ? "rgba(255,255,255,0.1)" : "gray.50" }}
              >
                <FormattedMessage id={route.name} />
                {/* {route.name === "find_my_agent" && (
                  <Box
                    bg="red.500"
                    color="white"
                    fontSize="10px"
                    px={1.5}
                    py={0.5}
                    borderRadius="full"
                    fontWeight="bold"
                    ml={1}
                  >
                    <FormattedMessage id="new" />
                  </Box>
                )}
                {route.name === "market_intelligence" && <ChevronDownIcon />} */}
              </Box>
            ))}
          </Flex>
        )}

        {mobileView && (
          <Box width="24px" display={{ base: "none", md: "block" }} /> /* Spacer for alignment */
        )}
      </Flex>
      {hamMenu && <HamMenu handleHamMenu={handleHamMenu} auth={auth} profileData={profileData} />}
      <Login />
    </Box>
  );
};

export default Header;
